import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./theme/theme.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
